import React, { FC } from "react"

import Button, { BUTTON_SIZES, ButtonProps } from "@components/Button/Button"
import Icon, { ICON_TYPES } from "@components/Icon/Icon"

import "./IconButton.scss"

export enum ICON_BUTTON_SIZES {
  "S" = "S",
  "M" = "M",
}

export enum ICON_BUTTON_VARIANTS {
  "PRIMARY" = "PRIMARY",
  "SECONDARY" = "SECONDARY",
  "OUTLINE" = "OUTLINE",
}

type IconButtonProps = Omit<ButtonProps, "children" | "size" | "variant"> & {
  iconType: ICON_TYPES,
  size?: ICON_BUTTON_SIZES,
  variant?: ICON_BUTTON_VARIANTS
}

const IconButton: FC<IconButtonProps> = ({
  iconType,
  size = ICON_BUTTON_SIZES.M,
  variant = ICON_BUTTON_VARIANTS.PRIMARY,
  ...buttonProps
}) => (
  <Button
    className="IconButton"
    {...{
      ...buttonProps,
      size,
      variant,
    }}
  >
    <Icon
      color="" // let CSS handle the color for this component
      size={
        size === BUTTON_SIZES.S ?
          "var(--spacing--base-1-5)" :
          "var(--spacing--base-2)"
      }
      type={iconType}
    />
  </Button>
)

export default IconButton
